export class Interval {
    _id;
    /**
     * Simple class which wraps window.setInterval, simply to make clients more testable
     */
    constructor() {
        this._id = undefined;
    }

    /**
     * Returns if the interval is currently running
     * @returns {boolean}
     */
    get isRunning() {
        return !!this._id;
    }

    /**
     * Start an interval
     * @param callback The callback to run
     * @param ms How often to run it (in milliseconds)
     * @param runNow Whether to run the callback straight away, and also on interval
     * @throws Error If this interval is already running
     */
    start(callback: Function, ms: number, runNow: boolean = false) {
        if (this.isRunning) {
            throw new Error(`Interval is already running, call stop() before starting again`);
        }
        if (runNow) {
            callback();
        }
        this._id = window.setInterval(callback, ms);
    }

    /**
     * Stop the currently running interval
     * @throws Error If this interval is not running
     */
    stop() {
        if (!this.isRunning) {
            throw new Error(`Interval is not running, call start() before stopping`);
        }
        window.clearInterval(this._id);
        this._id = undefined;
    }
}
